function BingoSquare(props) {
  return (
    <div key={props.gameRestartKey} className="bingo-square animate spin">
      {props.loser && <div className="loser"></div>}
      {props.selected && (
        <img
          key={props.gameRestartKey + "|" + props.selected}
          src="images/chip.svg"
          alt="Bingo Chip"
          className={`chip c-${props.index} animate drop`}
        />
      )}
      <a onClick={() => props.onClick(props.index)}>
        <img
          src={props.icon}
          className="square-img"
          alt="Bingo Square"
          data-index={props.index}
        />
      </a>
    </div>
  );
}

export default BingoSquare;
